import { createI18n } from 'vue-i18n'
import pt from '@/locales/pt.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'


function getInitialLocale() {
    try {
        const persistedStateJSON = localStorage.getItem('usuario-store')

        if (!persistedStateJSON) {
            return 'pt'
        }

        const persistedState = JSON.parse(persistedStateJSON)
        const savedLang = persistedState?.dadosUsuario?.idioma

        if (savedLang) {
            const lang = savedLang.substring(0, 2)
            const supportedLocales = ['pt', 'en', 'es']

            return supportedLocales.includes(lang) ? lang : 'pt'
        }
    } catch (error) {
        console.error('[i18n] Failed to read persisted language from localStorage:', error)
    }

    return 'pt'
}

export const i18n = createI18n({

    legacy: false,

    locale: getInitialLocale(),

    fallbackLocale: 'pt',

    pluralizationRules: {
        pt: function (choice, choicesLength) {
            return choice === 0 || choice === 1 ? 0 : 1
        },
    },

    messages: {
        pt,
        en,
        es,
    },

    dateTimeFormats: {
        pt: {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
            },
        },
        en: {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
            },
        },
        es: {
            short: {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            },
            long: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
            },
        },
    },

    numberFormats: {
        pt: {
            currency: {
                style: 'currency',
                currency: 'BRL',
                notation: 'standard',
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            percent: {
                style: 'percent',
                useGrouping: true,
            },
        },
        en: {
            currency: {
                style: 'currency',
                currency: 'USD',
                notation: 'standard',
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            percent: {
                style: 'percent',
                useGrouping: true,
            },
        },
        es: {
            currency: {
                style: 'currency',
                currency: 'EUR',
                notation: 'standard',
            },
            decimal: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            percent: {
                style: 'percent',
                useGrouping: true,
            },
        },
    },
})

export default i18n
